export default
    {
        // url: this.$store.state.http.indicas.YYYY,
        list: "/hospital/listIndicasSf",
        guarda: "/hospital/createindicaciones",
        imprime: "/hospital/getIndicasSf",
    }
